import {Validator} from './Validator';


const fixedNumber = (minLength: number, maxLength: number, message: string): Validator => (input: string) => {
  return (input && input.trim().length > 0) ? null : message;
};

export {fixedNumber};